<template>
  <v-container class="custom-container container" >
  <div class="list_form_card" >
    <h1>ข้อมูลรหัส</h1>
    <v-row >
      <v-col
      xl="4"
      lg="4"
      md="6"
      sm="12"
      class="col-form"
      >
        <v-text-field
            label="จำนวน"
            required
            v-model="amount"
        ></v-text-field>

        <v-select
            v-model="day"
            label="เลือกจำนวน/วัน"
            :items="[1,3,7]"
        ></v-select>

        <Buttons class="ml-2 mr-2"
                 title="สร้าง"
                 type="primary"
                 :cb="GenerateCode"
        />

      </v-col>

    </v-row>
    <v-row>
      <v-col class="filter-container-btn" >
        <button @click="status = 'all' " class="all_btn " >
          ทั้งหมด
        </button>

        <button @click="status = 'wait' " class="wait_btn " >
          ยังไม่ได้ใช้งาน
        </button>
        <button @click="status = 'active' " class="active_btn " >
          กำลังใช้งานอยู่
        </button>
        <button @click="status = 'expire' " class="expire_btn " >
          หมดอายุ
        </button>
      </v-col>
    </v-row>

    <v-row class="filter-check" >
      <v-col  >
        <v-text-field
            label="รหัส"
            required
            v-model="code"
        ></v-text-field>

      </v-col>
      <v-col>
      <Buttons class="ml-2 mr-2"
               title="ตรวจสอบ"
               type="link"
               :cb="CheckCode"
      />

      </v-col>

    </v-row>

    <div v-if="is_loading" class="loading" align="center" >
      <img src="../assets/image/loading3.svg" />
    </div>

    <div align="center" class="mt-8 mb-8" >
      <h1>จำนวน Code {{ data.length }}</h1>
    </div>

    <div align="right" class="mb-8" >
      <v-select
          v-model="itemPerpage"
          label="จำนวนที่ต้องการแสดง"
          :items="[50,100,500,1000,5000]"
      ></v-select>
      <Buttons class="ml-2 mr-2"
               title="Download รหัส"
               type="link"
               :cb="tableToExcel"
      />
    </div>

    <div class="table" style="display: none;" >
      <table ref="table" >
        <tr style="border: 1px solid #000" v-for="result in downloadList" :key="result.id" >
          <td style="border: 2px solid #000;font-size: 17px;" align="center" v-for="resultList in result" :key="resultList.id" >
            {{resultList.code}}
          </td>
        </tr>
      </table>
    </div>


    <v-row>



      <v-col v-for="result in data" :key="result.id" xl="2" lg="2" md="3" sm="12" xs="12" >
          <div align="center" >
            <CodeBlock
            status="wait"
            :data="result"
            />
          </div>
      </v-col>

    </v-row>
  </div>



  </v-container>


</template>

<script>
// @ is an alias to /src

import moment from "moment";
import CodeBlock from "../components/CodeBlock.vue";
import {ResponseData} from "../lib/utility";
import {CheckCode, GetCode, PostCode} from "../lib/controller";
import Buttons from "../components/Buttons/index.vue";

let today = new Date();
today.setHours(0, 0, 0, 0);
today.setDate(today.getDate() + 2);

let yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

let last7 = new Date();
last7.setDate(today.getDate() - 7);
last7.setHours(0, 0, 0, 0);

let last15 = new Date();
last15.setDate(today.getDate() - 15);
last15.setHours(0, 0, 0, 0);

export default {
  name: 'Home',
  computed: {
    moment() {
      return moment
    }
  },
  components: {
    Buttons,
    CodeBlock

  },
  data: () => ({
    type: 'month',
    value: '',
    code: '',
    amount:1,
    itemPerpage:50,
    downloadList:{},
    is_loading:false,
    uri :'data:application/vnd.ms-excel;base64,',
    template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
    format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })
    },
    day:1,
    status:"all",
    data:{},
    donate: [],
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
    ],
    dateRange: {
      startDate: last7,
      endDate: today,
    },
    dateFormat: "Y-m-d",
    Ranges: {
      '15 วันก่อนหน้า': [last15, today],
      'วันนี้': [today, today],
      'เมื่อวาน': [yesterday, yesterday],
      'ปีนี้': [
        new Date(today.getFullYear(), 0, 1),
        new Date(today.getFullYear(), 11, 31),
      ],
      'เดือนก่อน': [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0),
      ],
    },
    Lang: {
      direction: "ltr",
      format: "mm-dd-yyyy",
      separator: " - ",
      applyLabel: "ตกลง",
      cancelLabel: "ยกเลิก",
      weekLabel: "W",
      customRangeLabel: "เลือกช่วงเวลา",
      daysOfWeek: ["อา.", "จ.", "อ.", "พ.", "พฤ", "ศ", "ส"],
      monthNames: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ],
      firstDay: 1,
    }

  }),
  watch: {
    status(){
      this.GetCode();
    },
    itemPerpage(){
      this.GetCode();
    }
  },
  methods:{
    tableToExcel(table, name){

      if (!table.nodeType) table = this.$refs.table
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      window.location.href = this.uri + this.base64(this.format(this.template, ctx))
    },
    async GenerateCode(){
      this.is_loading = true;
      const param = {
        "amount":this.amount,
        "hour":(this.day*24),
      }

      await PostCode(param,(response)=>{

        const {status, data} = ResponseData(response)
        this.is_loading = false;

        switch (status){
          case 200:
              console.log(data);
              this.GetCode();
            break;

          case 404:
            break;

          case 422:
            break;

          case 429:
            break;

        }

      });
    },
    async GetCode(){
      this.is_loading = true;

      const params = {
        itemsPerPage:this.itemPerpage,
        status:this.status,
      }

      await GetCode(params,(response)=>{

        const {status, data} = ResponseData(response)
        this.is_loading = false;

        switch (status){
          case 200:
            console.log(data.data);
            this.data = data.data;
            this.downloadList = this.chunkArray(this.data,10);
            console.warn(this.data);
            console.warn(this.downloadList);
            break;

          case 404:
            break;

          case 422:
            break;

          case 429:
            break;

        }

      });
    },
    async CheckCode(){
      this.is_loading = true;

      await CheckCode(this.code,(response)=>{

        const {status, data} = ResponseData(response)
        this.is_loading = false;

        this.GetCode();

        switch (status){
          case 200:
            console.log(data)
            switch (data){
              case "wait":

                this.$swal({
                  title: "รอเปิดใช้งาน",
                  icon: "warning",
                  confirmButtonText: "ตกลง"
                }).then(async () => {
                });

                break;

              case "active":

                this.$swal({
                  title: "เปิดใช้งานอยู่",
                  icon: "success",
                  confirmButtonText: "ตกลง"
                }).then(async () => {
                });

                break

              case "expire":

                this.$swal({
                  title: "รหัสหมดอายุ",
                  icon: "warning",
                  confirmButtonText: "ตกลง"
                }).then(async () => {
                });

                break
            }
            break;

          case 404:

            this.$swal({
              title: "ไม่พบรหัส",
              text: "ไม่พบรหัสในระบบ",
              icon: "warning",
              confirmButtonText: "ตกลง"
            }).then(async () => {
            });

            break;

          case 422:
            break;

          case 429:
            break;

        }

      });
    },
     chunkArray(arr, size) {
  let result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}
  },
  async mounted() {
    this.GetCode();
  }
}
</script>
<style scoped >
.form_table{
  width: 80%;
}
.filter-container-btn{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.filter-check{
  width: 30%;
}
.all_btn{
  background: #146fec;
  color: white;
}

.all_btn.active{
  box-shadow: rgb(5 121 231 / 79%) 0px 3px 6px, rgb(5 51 229 / 88%) 0px 3px 6px;
}

.wait_btn{
  background: #bbc2cc;
  color: white;
}

.wait_btn.active{
  box-shadow: rgba(79, 76, 76, 0.79) 0px 3px 6px, rgba(106, 106, 107, 0.88) 0px 3px 6px;
}
.active_btn{
  background: #0bde00;
  color: white;
}
.active_btn.active{
  box-shadow: rgba(31, 209, 4, 0.79) 0px 3px 6px, rgba(61, 172, 6, 0.88) 0px 3px 6px;
}
.expire_btn{
  background: #f41a33;
  color: white;
}

.expire_btn.active{
  box-shadow: rgba(246, 6, 43, 0.79) 0px 3px 6px, rgba(134, 0, 22, 0.88) 0px 3px 6px;
}
</style>

